module.exports = __webpack_public_path__ + "img/Contacts.b7418f1a.svg";